import React from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import ButtonCreateJourney from '@components/ui/ButtonCreateJourney';
import Filters from '@components/application/JourneyManagement/Filters';
import * as Styled from './ActionsStyles';

function Actions() {
  return (
    <Styled.Wrapper>
      <div>
        <Filters />
      </div>
      <FuelFlex
        defaultProps={{
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 'km2',
        }}
      >
        <ButtonCreateJourney />
      </FuelFlex>
    </Styled.Wrapper>
  );
}

export default Actions;
